/**
 * The query keys the reads in this folder are cached under.
 *
 * The key lives apart from the query so the actions can write the signed-in
 * user back after changing them, without importing the query module and
 * closing an import cycle.
 */

// The signed-in user. Read once at start-up and kept current by the actions
// that change their email, password or PIN.
export const FETCH_ME_QUERY_KEY = 'fetchMe';
